import React, { Component } from "react";
import Icon from "../Common/Icon";
import connect from "react-redux/es/connect/connect";
import PropTypes from "prop-types";
import * as moment from "moment";
import "moment/locale/nl";
import Sharing from "../Storingen/Sharing";
import ReactModal from "react-modal";
import DienstregelingLink from "../Dienstregeling/Link";
import LineBadge from "../Haltes/LineBadge";

class List extends Component {
  static propTypes = {
    config: PropTypes.object
  };

  constructor() {
    super();

    this.state = {
      showAllDirections: [],
      modalAlertId: undefined
    };
  }

  handleOpenModal = alertId => {
    this.setState({ modalAlertId: alertId });
  };

  handleCloseModal = () => {
    this.setState({ modalAlertId: undefined });
  };

  showAllDirections = id => {
    const showAllDirections = this.state.showAllDirections.map(
      ({ alert_id, showDirections }, index) => ({
        alert_id,
        showDirections: alert_id === id ? !showDirections : showDirections
      })
    );
    this.setState({ showAllDirections });
  };

  createStopLink = (stop, baseUrl = '/') => {
    const nameAndTown = stop.Description.split(',');

    const queryStringParam = {
      stopid: `NL:S:${stop.Code}`,
      town: nameAndTown.length ? nameAndTown[0] : '?',
      name: nameAndTown.length >= 2 ? nameAndTown[1] : '?'
    }

    return `${baseUrl}?stop=${JSON.stringify(queryStringParam)}`;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.storingen === prevProps.storingen) return;

    const showAllDirections = this.props.storingen.map(({ alert_id }) => ({
      alert_id,
      showDirections: false
    }));
    this.setState({ showAllDirections });
  }

  render() {
    const { storingen, config, loading } = this.props;
    const { showAllDirections, modalAlertId } = this.state;

    let {
      lineText,
      directionText,
      typeText,
      fromText,
      toText,
      //todayText = 'Vandaag',
      //plannedText = 'Geplande omleidingen',
      moreInfoText,
      moreDirectionsText,
      lessDirectionsText,
      lineLinkBaseUrl,
      halteLinkBaseUrl,
      locale,
      cancelledStopsHeaderText = "Vervallen haltes",
      replacedStopsHeaderText = "Vervangende haltes",
      noCancelledStopText = 'N.v.t.',
      noReplacedStopText = 'N.v.t.',
      goToDienstregelingText = "Ga naar de dienstregeling van lijn ",
      noStoringenText = "Er zijn geen storingen"
    } = config;
    lineLinkBaseUrl = lineLinkBaseUrl || "/";

    moment.locale(locale || "nl");

    if (!storingen) return null;

    const modalStoring = storingen.find(
      storing => storing.alert_id === modalAlertId
    );

    return (
      <React.Fragment>
        {/* <div className={`storingen__navigation ${loading ? 'storingen__navigation--loading' : ''}`}>
          <div className="container container--margin container--center storingen__navigation-center">
            <div className="tabs">
              <div className="tabs__scroller js-tabs-scroller">
                <ul className="tabs__list">
                  <li className="tabs__item">
                    <button className="tabs__btn is-selected">{todayText}
                    </button>
                    <div className="tabs__indicator"></div>
                  </li>

                  <li className="tabs__item">
                    <button className="tabs__btn">{plannedText}
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div> */}

        <div className="storingen__list-header-wrapper container container--margin">
          <div className="storingen__list-header container--center">
            <div className="storingen-list__line-numbers">{lineText}</div>
            <div className="storingen-list__direction">{directionText}</div>
            <div className="storingen-list__type">{typeText}</div>
            <div className="storingen-list__from">{fromText}</div>
            <div className="storingen-list__to">{toText}</div>
            <div className="storingen-list__info" />
          </div>
        </div>

        <div
          className={`storingen__list-wrapper ${
            loading ? "storingen__list-wrapper--loading" : ""
            }`}
        >
        {(!storingen || !storingen.length)
          ? <div className="container container--margin container--center">{noStoringenText}</div>
          : (
            <ul className="storingen__list">
              {storingen.map(storing => {
                //@TODO refactor this
                let showDirection = showAllDirections.find(stateStoring =>
                  storing.alert_id === stateStoring.alert_id
                    ? stateStoring.showDirections
                    : false
                );
                if (showDirection) {
                  showDirection = showDirection.showDirections;
                }

                return (
                  <li className="storingen__list-item" key={storing.alert_id}>
                    <div className="container container--center storingen__list-container">
                      <strong className="storingen__list-title">
                        {config.lineText}
                      </strong>
                      <span className="sr-only mobile-only">{storing.lineText}:</span>
                      <div className="storingen-list__line-numbers">
                        {storing.routes.map(line => {
                          const {
                            route_id,
                            route_short_name,
                            route_long_name,
                            route_text_color,
                            route_color
                          } = line;

                          return (
                            <LineBadge
                              key={line.route_id}
                              className="link halte-lines__link"
                              route_id={route_id}
                              route_long_name={route_long_name}
                              route_short_name={route_short_name}
                              baseUrl={lineLinkBaseUrl}
                              route_text_color={route_text_color}
                              route_color={route_color}
                              accessibilityPrefixText={goToDienstregelingText}
                              text={route_short_name}
                            />
                          );
                        })}
                      </div>
                      <strong className="storingen__list-title">
                        {config.directionText}
                      </strong>
                      <span className="sr-only mobile-only">
                        {storing.directionText}:
                        </span>
                      <div className="storingen-list__direction">
                        <ul className="storingen-list__direction-list">
                          {storing.routes.map((line, index) =>
                            !showDirection && index >= 2 ? null : (
                              <li
                                key={line.route_id}
                                className="storingen-list__direction-item"
                              >
                                {line.route_long_name}
                              </li>
                            )
                          )}
                        </ul>
                        {storing.routes.length <= 2 ? null : (
                          <button
                            onClick={() =>
                              this.showAllDirections(storing.alert_id)
                            }
                            className="link storingen-list__more-directions"
                          >
                            {!showDirection
                              ? `${moreDirectionsText} +`
                              : `${lessDirectionsText} -`}
                          </button>
                        )}
                      </div>
                      <strong className="storingen__list-title">
                        {config.typeText}
                      </strong>
                      <span className="sr-only mobile-only">{storing.header}:</span>
                      <div className="storingen-list__type">
                        <strong>{storing.header}</strong>
                        <p>{storing.description}</p>
                      </div>
                      <strong className="storingen__list-title">
                        {config.fromText}
                      </strong>
                      <span className="sr-only mobile-only">{storing.fromText}:</span>
                      <div className="storingen-list__from">
                        {moment(storing.start_time).format("D MMM YYYY")}
                        <br />
                        {moment(storing.start_time).format("HH:mm")}
                      </div>
                      <strong className="storingen__list-title">
                        {config.toText}
                      </strong>
                      <span className="sr-only mobile-only">{storing.toText}:</span>
                      <div className="storingen-list__to">
                        {moment(storing.end_time).format("D MMM YYYY")}
                        <br />
                        {moment(storing.end_time).format("HH:mm")}
                      </div>
                      <div className="storingen-list__info">
                        <button
                          className="storingen-list__info-btn"
                          onClick={() =>
                            this.handleOpenModal(storing.alert_id)
                          }
                        >
                          <span className="sr-only">{moreInfoText}</span>
                          <span
                            className="storingen-list__info-icon"
                            aria-hidden="true"
                          >
                            i
                            </span>
                        </button>
                      </div>
                    </div>
                  </li>
                );
              })}
            </ul>
        )}
        </div>
        <div className="container container--center">
          <Sharing config={config ? config.sharing : {}} />
        </div>
        {!modalStoring ? null : (
          <ReactModal
            isOpen={!!modalStoring}
            style={{ overlay: {}, content: {} }}
            overlayClassName="modal__overlay"
            bodyOpenClassName="modal--open"
            shouldFocusAfterRender={false}
            className="modal"
          >
            <button
              onClick={this.handleCloseModal}
              className="modal__close-btn"
            >
              ✖
            </button>
            <div className="modal__content">
              <h2>{modalStoring.header}</h2>
              <p>{modalStoring.description}</p>

              {!modalStoring.stops.length ? (
                ""
              ) : (
                <React.Fragment>
                  <table className="halte__table mobile-hide">
                    <tbody>
                      <tr className="halte-table__row halte-table__row--heading">
                        <th className="halte-table__column halte-table__column--heading">{cancelledStopsHeaderText}</th>
                        <th className="halte-table__column halte-table__column--heading">{replacedStopsHeaderText}</th>
                      </tr>
                      {modalStoring.stops.map(stop => (
                        <tr key={JSON.stringify(stop)} className="halte-table__row">
                          <td>
                            {(stop.Code && halteLinkBaseUrl) 
                              ? <a href={this.createStopLink(stop, halteLinkBaseUrl)}>{stop.Description || noCancelledStopText}</a> 
                              : (stop.Description || noCancelledStopText)}
                          </td>
                          <td key={JSON.stringify(stop)} className="halte-table__column">
                            {stop.ReplacedBy.Remark || stop.ReplacedBy.Description|| noReplacedStopText}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className="halte__table mobile-only">
                    <ul className="halte-table__column">
                      <li className="halte-table__row halte-table__row--heading">
                        {cancelledStopsHeaderText}
                      </li>
                      {modalStoring.stops.map(stop => (
                        <li key={JSON.stringify(stop)} className="halte-table__row">
                          {(stop.Code && halteLinkBaseUrl) 
                            ? <a href={this.createStopLink(stop, halteLinkBaseUrl)}>{stop.Description || noCancelledStopText}</a> 
                            : (stop.Description || noCancelledStopText)}
                        </li>
                      ))}
                    </ul>
                    <ul className="halte-table__column">
                      <li className="halte-table__row halte-table__row--heading">
                        {replacedStopsHeaderText}
                      </li>
                      {modalStoring.stops.map(stop => (
                        <li key={JSON.stringify(stop)} className="halte-table__row">
                          {stop.ReplacedBy.Remark || stop.ReplacedBy.Description|| noReplacedStopText}
                        </li>
                      ))}
                    </ul>
                  </div>
                </React.Fragment>
              )}

              {!modalStoring.routes.length ? (
                ""
              ) : (
                  <ul className="list--reset">
                    {modalStoring.routes.map(
                      ({ route_id, route_long_name, route_short_name }) => (
                        <li key={route_short_name}>
                          <DienstregelingLink
                            className="link link--animation-on-hover"
                            route_id={route_id}
                            route_long_name={route_long_name}
                            route_short_name={route_short_name}
                            //date={date}
                            //time={time}
                            //directionId={0}
                            baseUrl={lineLinkBaseUrl}
                          >
                            {goToDienstregelingText} {route_short_name}
                            <Icon
                              className="btn__icon btn__icon--right"
                              iconName="arrow-right"
                            />
                          </DienstregelingLink>
                        </li>
                      )
                    )}
                  </ul>
                )}

              <Sharing config={config ? config.sharing : {}} />
            </div>
          </ReactModal>
        )}
      </React.Fragment>
    );
  }
}

export default connect(
  state => {
    return state.storingen;
  },
  {}
)(List);



// WEBPACK FOOTER //
// ./src/components/Storingen/List.js